import React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    className={className}
  >
    <g transform="translate(-19.594 -19.594)">
      <g transform="translate(19.594 19.594)">
        <path
          d="M30.2,971.957l-4.6,4.6-4.6-4.6-1.4,1.4,4.6,4.6-4.6,4.6,1.4,1.4,4.6-4.6,4.6,4.6,1.4-1.4-4.6-4.6,4.6-4.6Z"
          transform="translate(-19.594 -971.957)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
